import { render, staticRenderFns } from "./AppAddInstruction.vue?vue&type=template&id=f361f998&scoped=true&"
import script from "./AppAddInstruction.vue?vue&type=script&lang=ts&"
export * from "./AppAddInstruction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f361f998",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
